export const logIn = (credentials) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    dispatch({ type: "DOING_LOGIN" });

    firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        firebase
          .auth()
          .signInWithEmailAndPassword(credentials.email, credentials.password)
          .then((res) => {
            // fetch the user data
            dispatch({ type: "LOGIN_SUCCESS", data: res });
          })
          .catch((err) => {
            dispatch({ type: "LOGIN_FAILED", data: err });
          });
      })
      .catch((err) => {
        dispatch({ type: "LOGIN_FAILED", data: err });
      });
  };
};

export const subscribe = (credentials) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    dispatch({ type: "DOING_SUBSCRIBE" });

    firebase
      .auth()
      .createUserWithEmailAndPassword(credentials.email, credentials.password)
      .then((res) => {
        dispatch({ type: "SUBSCRIBE_SUCCESS", data: res });
      })
      .catch((err) => {
        dispatch({ type: "SUBSCRIBE_FAILED", data: err });
      });
  };
};

export const logOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    dispatch({ type: "DOING_LOGOUT" });

    localStorage.removeItem("totpJwt");

    firebase
      .auth()
      .signOut()
      .then((res) => {
        dispatch({ type: "LOGOUT_SUCCESS", data: res });
      })
      .catch((err) => {
        dispatch({ type: "LOGOUT_FAILED", data: err });
      });
  };
};

export const setUserInfos = (data) => (dispatch) => {
  dispatch({ type: "SET_USER_INFOS", payload: data });
};

export const setUserInfosJwt = (newJwt) => (dispatch) => {
  dispatch({ type: "SET_USER_INFOS_JWT", payload: newJwt });
};

export const setCreatorUid = (uid) => (dispatch) => {
  dispatch({ type: "SET_CREATOR_UID", payload: uid });
};
